import * as React from 'react';

import { ChatSidebarView } from './chat/_ChatSidebarView';

export const AssistantSidebarContent: React.FC = () => (
  <div className="@AssistantSidebarContent h-full w-full">
    <ChatSidebarView />
  </div>
);
